import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import ChatBot from './ChatBot';

const WHATSAPP_NUMBER = '595991344956';

const FloatingButtons = () => {
  const [chatOpen, setChatOpen] = useState(false);

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=Hola%20Zenex!%20Tengo%20una%20consulta`, '_blank');
  };

  return (
    <>
      <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 flex flex-col gap-3 sm:gap-4">
        {/* Chatbot Button */}
        <button
          onClick={() => setChatOpen(!chatOpen)}
          className="group relative w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center"
          title="Chat con Asistente IA"
          data-testid="chatbot-toggle"
        >
          <div className="relative">
            <img 
              src="https://customer-assets.emergentagent.com/job_9f79b292-d9d5-4e5e-9601-bb175f5ef285/artifacts/3g9iwewq_11.png"
              alt="Zenex Chat"
              className="w-7 h-7 sm:w-10 sm:h-10"
            />
            <div className="absolute -top-1 -right-1 w-2.5 h-2.5 sm:w-3 sm:h-3 bg-blue-400 rounded-full border-2 border-white animate-pulse"></div>
          </div>
          
          {/* Tooltip - solo desktop */}
          <div className="hidden sm:block absolute right-full mr-3 px-3 py-2 bg-zinc-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            Chat con IA
            <div className="absolute top-1/2 -right-1 w-2 h-2 bg-zinc-900 transform rotate-45 -translate-y-1/2"></div>
          </div>
        </button>

        {/* WhatsApp Button */}
        <button
          onClick={handleWhatsApp}
          className="group relative w-12 h-12 sm:w-16 sm:h-16 bg-[#25D366] rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-110 flex items-center justify-center"
          title="Contactar por WhatsApp"
          data-testid="whatsapp-toggle"
        >
          <MessageCircle className="text-white" size={24} />
          
          {/* Tooltip - solo desktop */}
          <div className="hidden sm:block absolute right-full mr-3 px-3 py-2 bg-zinc-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            WhatsApp
            <div className="absolute top-1/2 -right-1 w-2 h-2 bg-zinc-900 transform rotate-45 -translate-y-1/2"></div>
          </div>
        </button>
      </div>

      <ChatBot isOpen={chatOpen} onClose={() => setChatOpen(false)} />
    </>
  );
};

export default FloatingButtons;